export default "__VITE_ASSET__d05766b6__"